import { motion } from "framer-motion";
import { Braces, Database, LayoutTemplate, Network, UsersRound, Waypoints } from "lucide-react";
import { skillCategories } from "../data";

const icons = [LayoutTemplate, Network, Braces, Database, Waypoints, UsersRound];
const statusStyles = {
  "Used in projects": "border-cyan-300/30 bg-cyan-300/10 text-cyan-100",
  Comfortable: "border-emerald-300/30 bg-emerald-300/10 text-emerald-100",
  Learning: "border-purple-300/30 bg-purple-300/10 text-purple-100",
};

export default function Skills() {
  return (
    <section id="skills" className="section-shell">
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.25 }}
        transition={{ duration: 0.6 }}
        className="mx-auto max-w-3xl text-center"
      >
        <p className="text-sm font-bold uppercase tracking-[0.35em] text-cyan-200">Миний чадварууд</p>
        <h2 className="mt-4 font-display text-3xl font-black text-white sm:text-5xl">Миний чадварууд</h2>
      </motion.div>

      <div className="mt-12 grid gap-5 md:grid-cols-2 xl:grid-cols-3">
        {skillCategories.map((category, index) => {
          const Icon = icons[index];
          return (
            <motion.article
              key={category.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.55, delay: index * 0.06 }}
              className="glass-card group p-6 transition duration-300 hover:-translate-y-1 hover:border-purple-300/35 hover:shadow-purple-glow"
            >
              <div className="mb-5 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                <div className="flex min-w-0 items-center gap-3">
                  <span className="grid h-11 w-11 shrink-0 place-items-center rounded-2xl bg-gradient-to-br from-cyan-300/20 to-purple-400/20 text-cyan-100 sm:h-12 sm:w-12">
                    <Icon size={24} />
                  </span>
                  <h3 className="min-w-0 text-base font-extrabold text-white sm:text-lg">{category.title}</h3>
                </div>
                <span
                  className={`w-fit rounded-full border px-3 py-1 text-xs font-black ${
                    statusStyles[category.status] ?? "border-white/10 bg-white/5 text-slate-200"
                  }`}
                >
                  {category.status}
                </span>
              </div>

              <div className="mt-5 flex flex-wrap gap-2">
                {category.skills.map((skill) => (
                  <span key={skill} className="skill-badge">
                    {skill}
                  </span>
                ))}
              </div>
            </motion.article>
          );
        })}
      </div>
    </section>
  );
}
